// Number of screens that show a step indicator in the onboarding flow.
export const TOTAL_ONBOARDING_STEPS = 4;
